<template>
  <RxkDrawer
    v-model:visible="innerVisible"
    :title="title"
    :size="700"
    @close="handleClose"
    :showPrimaryBtn="!preView"
    :cancelText="preView ? '关闭' : cancelBtn"
    :primary-text="saveBtn"
    v-bind="$attrs"
    @confirm="sure"
  >
    <template #content>
      <div class="addForm-box">
        <el-form :model="formData" ref="formDataRef" label-position="top">
          <template v-for="(item, index) in positions" :key="index">
            <template v-if="item.code === 'BLANK' && item.modules[0].show">
              <SubField
                v-if="item.modules && item.modules[0]?.moduleType === moduleType.subField"
                :formData="formData"
                :moduleData="item.modules[0]"
                :select="select"
                :quoteMappingConfig="quoteMappingConfig"
                :quoteDataIdList="quoteDataIdList"
                :quoteTableCode="quoteTableCode"
                :positions="positions"
              />
              <SubList
                :ref="(el: any) => setRefMap(el, item.modules[0])"
                :moduleData="item.modules[0]"
                :positions="positions"
                :subListData="subListData"
                :quoteMappingConfig="quoteMappingConfig"
                v-if="item.modules && item.modules[0]?.moduleType === moduleType.subList"
                :formData="formData"
              />
              <SubForm
                :moduleData="item.modules[0]"
                :formData="formData"
                :positions="positions"
                v-if="item.modules && item.modules[0]?.moduleType === moduleType.subForm"
              />
            </template>
            <template v-if="item.code === 'TABLE'">
              <div class="sub-table-box">
                <el-tabs class="customTabs" type="border-card" @tab-click="tabClick">
                  <el-tab-pane
                    v-for="(sub, index) in item.children"
                    :key="index"
                    :label="sub.title"
                  >
                    <template v-for="moduleItem in sub.modules" :key="moduleItem.id">
                      <template v-if="moduleItem.show">
                        <SubField
                          v-if="moduleItem.moduleType === moduleType.subField"
                          :formData="formData"
                          :positions="positions"
                          :moduleData="moduleItem"
                          :quoteMappingConfig="quoteMappingConfig"
                          :quoteDataIdList="quoteDataIdList"
                          :quoteTableCode="quoteTableCode"
                          :select="select"
                        />
                        <SubList
                          :ref="(el: any) => setRefMap(el, moduleItem)"
                          :moduleData="moduleItem"
                          :positions="positions"
                          :quoteMappingConfig="quoteMappingConfig"
                          :quoteDataIdList="quoteDataIdList"
                          :subListData="subListData"
                          v-if="moduleItem.moduleType === moduleType.subList"
                          :formData="formData"
                        />
                        <SubForm
                          :moduleData="moduleItem"
                          :positions="positions"
                          :formData="formData"
                          v-if="moduleItem.moduleType === moduleType.subForm"
                        />
                      </template>
                    </template>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </template>
          </template>
        </el-form>
      </div>
    </template>
  </RxkDrawer>
</template>
<script lang="ts" setup>
import { RxkDrawer } from '@/components/common/RxkDrawer'
import { useForm } from './hooks/useForm'
import { computed, onMounted, ref, defineEmits, PropType, provide, unref } from 'vue'
import SubField from './components/subField.vue'
import SubList from './components/subList.vue'
import SubForm from './components/subForm.vue'
import { moduleType } from '@/enums/preObjectManage'
import { crudInsert, tableSubmitVerifyApi } from '@/apis/objectManage'
import { isArray, isEmpty, isNullOrUndefOrEmpty, isNumber, isFunc } from '@/utils/is'
import { cloneDeep } from '@/utils/tools'
import {
  advancedFilterLabelStrategy,
  findField,
  isAssociatedQuery
} from '@/utils/preObjectManage/utils'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  tableCode: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: '新增'
  },
  formData: {
    type: Object as PropType<Recordable>,
    default: () => {}
  },
  taskGuid: {
    // 业务流程处理时需要传
    type: String,
    default: ''
  },
  processGuid: {
    // 审批流程重新发起
    type: String,
    default: ''
  },
  orderType: {
    type: Number,
    default: 0,
    desc: '客户类型 0-客户 1-线索'
  },
  defaultValue: {
    type: Object,
    default: () => ({})
  },

  afterResponseErrorHook: {
    type: Function
  },
  // 数据提交前需要处理数据
  beforeRequestHook: {
    type: Function
  },
  preView: {
    type: Boolean,
    default: false
  },
  quoteDataIdList: {
    type: Array as PropType<Recordable[]>,
    default: () => []
  },
  quoteTableCode: {
    type: String,
    default: ''
  },
  subListData: {
    type: Array,
    default: () => []
  }
})
const emit = defineEmits(['update:visible', 'addSuccess', 'close'])
const innerVisible = computed({
  get: () => props.visible,
  set: (visible: boolean) => emit('update:visible', visible)
})
function tabClick(data: any) {
  console.log(data, 'data1')
}
const {
  getFormLayout,
  formData,
  select,
  positions,
  quoteMappingConfig,
  visibleBox,
  layoutVisibleBox,
  allBtnListData,
  equationList,
  tableInfo,
  associaFormCondition
} = useForm(props)

onMounted(() => {
  getFormLayout()
})

// 处理保存按钮
const saveBtn = computed(() => {
  let label = '保存'
  const cur = unref(allBtnListData).find(item => item.defineType === 10 && item.code === 'SAVE')
  return cur ? cur.title : label
})
// const showSaveBtn = computed(() => {
//   const cur = unref(allBtnListData).find(item => item.defineType === 10 && item.code === 'SAVE' && item.value)
//   return !!cur
// })
// 处理取消按钮
const cancelBtn = computed(() => {
  let label = '取消'
  const cur = unref(allBtnListData).find(item => item.defineType === 10 && item.code === 'CANCEL')
  return cur ? cur.title : label
})
// const showCancelBtn = computed(() => {
//   const cur = unref(allBtnListData).find(item => item.defineType === 10 && item.code === 'CANCEL' && item.value)
//   return !!cur
// })
provide('associaFormCondition', associaFormCondition)

function refreshVisible(field: Recordable, value: any) {
  // 处理字段的显隐
  dealVisibleControl(unref(visibleBox), field, value)
  // 处理布局的显隐
  dealVisibleControl(unref(layoutVisibleBox), field, value)
  // 处理按钮的显隐
  allBtnListData.value.forEach(item => {
    if (item.visibleList) {
      const current = item.visibleList.find(sub => sub.value === value)
      if (current) {
        if (current.actionSerial === '2') {
          item.show = false
        }
        if (current.actionSerial === '1') {
          item.show = true
        }
      }
    }
  })
  // console.log(allBtnListData, 'allBtnListData123')
}
function dealVisibleControl(list: Recordable[], field: Recordable, value: any) {
  if (unref(list).length) {
    // 处理：选项值为字符串，但是当前值为数字
    const _value = isNumber(value) ? String(value) : value

    // controlSerial就是当前单选字段
    // 从所有显隐规则中取出当前单选字段配置的显隐规则
    const newArr = unref(list).filter(item => item.controlSerial === field.fieldSerial)
    // 接收到该字段和值，然后处理字段的显示隐藏
    const cur = unref(newArr).find(item => item.value === _value)
    if (!cur) {
      // 如果当前值不在显隐规则中，则将该字段配置了显隐规则的全隐藏
      unref(newArr).forEach(item => {
        dealVisibleData(field, item, false)
      })
    } else {
      // 选择值
      if (_value) {
        // 选了选项1，配置了要显示那些字段
        // 选了选项2，也配置了要显示那些字段
        unref(newArr).forEach(item => {
          if (item.value === _value) {
            dealVisibleData(field, item, true, cur)
          } else {
            dealVisibleData(field, item, false, cur)
          }
        })
      } else {
        // 清空值
        unref(newArr).forEach(item => {
          dealVisibleData(field, item, false)
        })
      }
    }
  }
}
function dealVisibleData(
  field: Recordable,
  item: Recordable,
  bool: boolean,
  selectItem?: Recordable
) {
  changeCharge(bool)
  // 当前actionSerial可能在被选的选项的配置中存在
  const actionSerial = item.actionSerial.split(',')
  let arr: string[] = []
  if (selectItem) {
    arr = selectItem.actionSerial.split(',')
  }
  actionSerial.forEach(serial => {
    if (arr.includes(serial)) {
      field.renderConfig.visibleEmitter.emit(`addVisible_${serial}`, true)
    } else {
      field.renderConfig.visibleEmitter.emit(`addVisible_${serial}`, bool)
    }
  })
}
// 计费标准为 佣金比例， 应收服务费 禁用
function changeCharge(bool: boolean) {
  let field = findField(positions.value, '1768199250032193536')
  !isNullOrUndefOrEmpty(field) && (field.renderConfig.disabled = bool)
}

provide('refreshVisible', refreshVisible)

provide('equationList', equationList)

const refMap: Record<string, any> = {}
const setRefMap = (el: any, item: Recordable) => {
  const name = `subList_${item.id}`
  console.log(name, 'name1')
  console.log(el, 'el11', item)
  if (el) {
    refMap[name] = ref(el)
  }
}
// 子表数据验证
function validateSubList() {
  console.log(refMap, 'refMap')
  // 没有子表
  if (isEmpty(refMap)) {
    return true
  }
  const flagReturn = Object.keys(refMap).every(key => {
    const flag = refMap[key].value.validateTableData()
    console.log(flag, 'flag222')
    return !!flag
  })
  return flagReturn
}
const formDataRef = ref()
provide('formDataRef', formDataRef)
function sure(fn: Fn) {
  let shopOrderId = ''
  // 注意验证失败也要关闭按钮loading
  // 验证子表和分栏
  formDataRef.value.validate(valid => {
    if (valid) {
      const subFlag = validateSubList()
      if (subFlag) {
        let postData: Recordable = {
          dataId: 0,
          groups: [],
          subLists: [],
          tableCode: props.tableCode,
          type: 0
        }
        console.log(positions, 'positions123')
        // @todo 还有很多细节要处理
        positions.value.forEach(container => {
          if (container.code === 'BLANK') {
            container.modules.forEach((module: Recordable, mIndex: number) => {
              if (module.moduleType === moduleType.subField && module.show) {
                postData.groups.push({
                  moduleId: module.id,
                  columns: []
                })
                module.componentList.forEach((field: Recordable) => {
                  console.log(field, 'field456')
                  const { fieldCode, code, fieldSerial, fieldType, columnQuoteInfo } = field
                  let val = !isNullOrUndefOrEmpty(formData.value[fieldCode])
                    ? isArray(formData.value[fieldCode])
                      ? formData.value[fieldCode].join(',')
                      : formData.value[fieldCode]
                    : ''
                  // 如果有流水号，特殊处理
                  // if (code === fieldTypeConfig.serial) {
                  //   val = formData.value[fieldCode] || 'AUTOINCREMENT'
                  // }
                  if (field?.renderConfig?.valCallback) {
                    val = field.renderConfig.valCallback(val, field)
                  }
                  console.log(val, 'val88', field?.name)
                  let valCheck = true
                  // 新增布局可以提交
                  // if (isString(val) && val.includes('*')) {
                  //   valCheck = false
                  // }
                  if (val && field.show && valCheck) {
                    console.log(field, 'field9900')
                    // 还要传label
                    let label = ''
                    if (field.dataMark === 0) {
                      label = val
                    } else if (field.dataMark === 1 || field.dataMark === 2) {
                      const getResFn = advancedFilterLabelStrategy[code]
                      label = getResFn ? getResFn(field, { [code]: val }, code) : val
                      // 取label
                    }
                    const cuIndex = postData.groups.findIndex(
                      (cur: Recordable) => cur.moduleId === module.id
                    )
                    const saveData: Recordable = {
                      columnId: field.id,
                      value: val,
                      columnSerial: fieldSerial,
                      label
                    }
                    // 呼叫中心新增客户时-客户手机号码和主要联系人手机号码明文处理
                    if (['1743166786575980925', '1743169784381956096'].includes(fieldSerial)) {
                      if (val.includes('****') && formData.value?.plaintextPhone) {
                        saveData.value = formData.value.plaintextPhone
                        saveData.label = formData.value.plaintextPhone
                      }
                    }
                    // 呼叫中心新增客户时-客户名称明文处理
                    if (['1743169774143660032'].includes(fieldSerial)) {
                      if (
                        saveData.value === formData.value?.originRealName &&
                        formData.value?.plaintextName
                      ) {
                        saveData.value = formData.value.plaintextName
                        saveData.label = formData.value.plaintextName
                      }
                    }

                    // 关联已有数据
                    if (field.defaultMark === 1) {
                      saveData.defaultQuoteDataId = field.renderConfig.defaultQuoteDataId || ''
                      saveData.defaultQuoteValue = field.renderConfig.defaultQuoteValue || ''
                    }

                    // 引用映射字段
                    if (isAssociatedQuery(fieldType)) {
                      saveData.quoteTableCode = columnQuoteInfo.sourceTableCode
                      saveData.quoteColumnSerial = columnQuoteInfo.sourceColumnSerial
                      saveData.quoteDataId = field.renderConfig.id || 0
                      if (props.quoteTableCode === columnQuoteInfo.quoteTableCode)
                        shopOrderId = field.renderConfig.id
                    }
                    postData.groups[cuIndex].columns.push({ ...saveData })
                  }
                  // 针对于关联字段，即使没有输入值，也将字段信息传入接口，主要解决客户阶段在客户管理改了，需要同步到预约上门这边
                  else if (
                    val === '' &&
                    columnQuoteInfo?.sourceTableCode &&
                    columnQuoteInfo?.sourceColumnSerial &&
                    field?.renderConfig?.id
                  ) {
                    // 还要传label
                    let label = ''
                    if (field.dataMark === 0) {
                      label = val
                    } else if (field.dataMark === 1 || field.dataMark === 2) {
                      const getResFn = advancedFilterLabelStrategy[code]
                      label = getResFn ? getResFn(field, { [code]: val }, code) : val
                      // 取label
                    }
                    const cuIndex = postData.groups.findIndex(
                      (cur: Recordable) => cur.moduleId === module.id
                    )
                    const saveData: Recordable = {
                      columnId: field.id,
                      value: val,
                      columnSerial: fieldSerial,
                      label
                    }
                    // 引用映射字段
                    if (isAssociatedQuery(fieldType)) {
                      saveData.quoteTableCode = columnQuoteInfo.sourceTableCode
                      saveData.quoteColumnSerial = columnQuoteInfo.sourceColumnSerial
                      saveData.quoteDataId = field.renderConfig.id || 0
                      if (props.quoteTableCode === columnQuoteInfo.quoteTableCode)
                        shopOrderId = field.renderConfig.id
                    }
                    postData.groups[cuIndex].columns.push({ ...saveData })
                  }
                })
                postData.groups = postData.groups.filter(item => item.columns.length)
              }
              if (module.moduleType === moduleType.subList && module.show) {
                const name = `subList_${module.id}`
                const list = refMap[name].value.getSubListData()
                const copyList = cloneDeep(list).map(item => {
                  delete item.quoteDataId
                  return {
                    ...item
                  }
                })
                let arr: Recordable[] = []
                arr = copyList.map((item: Recordable, index: any) => {
                  const columns = Object.keys(item)
                    .filter(sub =>
                      module.componentList.find((item: Recordable) => item.fieldCode === sub)
                    )
                    .map(sub => {
                      const current = module.componentList.find(
                        (item: Recordable) => item.fieldCode === sub
                      )
                      let val = item[sub]
                        ? isArray(item[sub])
                          ? item[sub].join(',')
                          : item[sub]
                        : ''
                      if (current?.renderConfig?.valCallback) {
                        val = current.renderConfig.valCallback(val, current)
                      }

                      // 还要传label
                      let label = ''
                      if (current?.dataMark === 0) {
                        label = val
                      } else if (current?.dataMark === 1 || current?.dataMark === 2) {
                        const getResFn = advancedFilterLabelStrategy[current?.code]
                        label = getResFn
                          ? getResFn(current, { [current?.code]: val }, current?.code)
                          : val
                        // 取label
                      }

                      const saveData: Recordable = {
                        columnId: current?.id,
                        value: val,
                        columnSerial: current?.fieldSerial,
                        label
                      }
                      // 引用映射字段
                      if (isAssociatedQuery(current?.fieldType)) {
                        saveData.quoteTableCode = current?.columnQuoteInfo?.sourceTableCode
                        saveData.quoteColumnSerial = current?.columnQuoteInfo?.sourceColumnSerial
                        saveData.quoteDataId = list[index].quoteDataId || 0
                      }
                      return saveData
                    })

                  return {
                    columns: columns.filter(item => {
                      let valCheck = true
                      // 新增布局可以提交
                      // if (isString(item.value) && item.value.includes('*')) {
                      //   valCheck = false
                      // }
                      return !isNullOrUndefOrEmpty(item.value) && valCheck
                    }),
                    delete: false,
                    rowDataId: 0
                  }
                })
                arr = arr.filter(item => item.columns.length)
                if (arr.length) {
                  postData.subLists.push({
                    defineType: module.defineType,
                    moduleGroup: module.group,
                    rows: arr
                  })
                }
              }
            })
          }
          if (container.code === 'TABLE') {
            container.children.forEach((child: Recordable) => {
              child.modules.forEach((module: Recordable, mIndex: number) => {
                if (module.moduleType === moduleType.subField && module.show) {
                  postData.groups.push({
                    moduleId: module.id,
                    columns: []
                  })
                  module.componentList.forEach((field: Recordable) => {
                    const { fieldCode, code, fieldSerial, fieldType, columnQuoteInfo } = field
                    let val = !isNullOrUndefOrEmpty(formData.value[fieldCode])
                      ? isArray(formData.value[fieldCode])
                        ? formData.value[fieldCode].join(',')
                        : formData.value[fieldCode]
                      : ''
                    // 如果有流水号，特殊处理
                    // if (code === fieldTypeConfig.serial) {
                    //   val = formData.value[fieldCode] || 'AUTOINCREMENT'
                    // }
                    if (field?.renderConfig?.valCallback) {
                      val = field.renderConfig.valCallback(val, field)
                    }
                    if (val && field.show) {
                      // 还要传label
                      let label = ''
                      if (field.dataMark === 0) {
                        label = val
                      } else if (field.dataMark === 1 || field.dataMark === 2) {
                        const getResFn = advancedFilterLabelStrategy[code]
                        label = getResFn ? getResFn(field, { [code]: val }, code) : val
                        // 取label
                      }
                      const cuIndex = postData.groups.findIndex(
                        (cur: Recordable) => cur.moduleId === module.id
                      )
                      const saveData: Recordable = {
                        columnId: field.id,
                        value: val,
                        columnSerial: fieldSerial,
                        label
                      }

                      // 关联已有数据
                      if (field.defaultMark === 1) {
                        saveData.defaultQuoteDataId = field.renderConfig.defaultQuoteDataId || ''
                        saveData.defaultQuoteValue = field.renderConfig.defaultQuoteValue || ''
                      }

                      // 引用映射字段
                      if (isAssociatedQuery(fieldType)) {
                        saveData.quoteTableCode = columnQuoteInfo.sourceTableCode
                        saveData.quoteColumnSerial = columnQuoteInfo.sourceColumnSerial
                        saveData.quoteDataId = field.renderConfig.id || 0
                      }
                      postData.groups[cuIndex].columns.push({ ...saveData })
                    }
                  })
                  postData.groups = postData.groups.filter(item => item.columns.length)
                }
                if (module.moduleType === moduleType.subList && module.show) {
                  console.log(refMap, 'refMap2233')
                  const name = `subList_${module.id}`
                  const list = refMap[name].value.getSubListData()
                  const copyList = cloneDeep(list).map(item => {
                    delete item.quoteDataId
                    return {
                      ...item
                    }
                  })
                  let arr: Recordable[] = []
                  arr = copyList.map((item: Recordable, index: any) => {
                    const columns = Object.keys(item)
                      .filter(sub =>
                        module.componentList.find((item: Recordable) => item.fieldCode === sub)
                      )
                      .map(sub => {
                        const current = module.componentList.find(
                          (item: Recordable) => item.fieldCode === sub
                        )
                        let val = item[sub]
                          ? isArray(item[sub])
                            ? item[sub].join(',')
                            : item[sub]
                          : ''
                        if (current?.renderConfig?.valCallback) {
                          val = current.renderConfig.valCallback(val, current)
                        }

                        // 还要传label
                        let label = ''
                        if (current?.dataMark === 0) {
                          label = val
                        } else if (current?.dataMark === 1 || current?.dataMark === 2) {
                          const getResFn = advancedFilterLabelStrategy[current?.code]
                          label = getResFn
                            ? getResFn(current, { [current?.code]: val }, current?.code)
                            : val
                          // 取label
                        }
                        const saveData: Recordable = {
                          columnId: current?.id,
                          value: val,
                          columnSerial: current?.fieldSerial,
                          label
                        }
                        // 引用映射字段
                        if (isAssociatedQuery(current?.fieldType)) {
                          saveData.quoteTableCode = current?.columnQuoteInfo.sourceTableCode
                          saveData.quoteColumnSerial = current?.columnQuoteInfo.sourceColumnSerial
                          saveData.quoteDataId = list[index].quoteDataId || 0
                        }
                        return saveData
                      })
                    return {
                      columns: columns.filter(item => !isNullOrUndefOrEmpty(item.value)),
                      delete: false,
                      rowDataId: 0
                    }
                  })
                  arr = arr.filter(item => item.columns.length)
                  if (arr.length) {
                    postData.subLists.push({
                      defineType: module.defineType,
                      moduleGroup: module.group,
                      rows: arr
                    })
                  }
                }
              })
            })
          }
        })
        if (props.taskGuid) {
          postData.taskGuid = props.taskGuid
        }
        if (props.processGuid) {
          postData.processGuid = props.processGuid
        }
        postData = isFunc(props.beforeRequestHook) ? props.beforeRequestHook!(postData) : postData
        if (tableInfo.value.conditionInfo) {
          const conditionInfo = JSON.parse(JSON.stringify(tableInfo.value.conditionInfo))
          tableSubmitVerifyApi({
            persistDataReq: { ...postData },
            unionSerial: conditionInfo.unionSerial,
            serialNo: conditionInfo.seriesNo
          }).then(res => {
            if (res) {
              crudInsert({
                ...postData,
                customerReq: {
                  orderType: props.orderType,
                  ...postData?.customerReq,
                  shopOrderId
                }
              })
                .then(res => {
                  fn && fn()
                  ElMessage.success(
                    tableInfo.value.switchSubmitTips === 1 && tableInfo.value.tableSubmitPrompt
                      ? tableInfo.value.tableSubmitPrompt
                      : '新增成功'
                  )
                  emit('addSuccess', res)
                })
                .catch((err: any) => {
                  fn && fn()
                  isFunc(props.afterResponseErrorHook) && props.afterResponseErrorHook!(err)
                })
            } else {
              fn && fn()
              ElMessage.error(conditionInfo.failPrompt)
            }
          })
        } else {
          crudInsert({
            ...postData,
            customerReq: {
              orderType: props.orderType,
              ...postData?.customerReq,
              shopOrderId
            }
          })
            .then(res => {
              fn && fn()
              ElMessage.success(
                tableInfo.value.switchSubmitTips === 1 && tableInfo.value.tableSubmitPrompt
                  ? tableInfo.value.tableSubmitPrompt
                  : '新增成功'
              )
              emit('addSuccess', res)
            })
            .catch((err: any) => {
              fn && fn()
              isFunc(props.afterResponseErrorHook) && props.afterResponseErrorHook!(err)
            })
        }
      } else {
        fn && fn()
      }
    } else {
      fn && fn()
    }
  })
}
function handleClose() {
  innerVisible.value = false
  removeEmitFn()
  emit('close')
}

// 移除所有监听事件
function removeEmitFn() {
  positions.value.forEach(container => {
    if (container.code === 'BLANK') {
      container.modules.forEach((module: Recordable) => {
        module.visibleEmitter.remove(`addVisible_${module.moduleSerial}`)
        module.componentList.forEach((field: Recordable) => {
          field.renderConfig.visibleEmitter.remove(`addVisible_${field.fieldSerial}`)
          field.renderConfig.equationEmitter.remove(`equation_${field.fieldSerial}`)
        })
      })
    }
    if (container.code === 'TABLE') {
      container.children.forEach((child: Recordable) => {
        child.modules.forEach((module: Recordable) => {
          module.visibleEmitter.remove(`addVisible_${module.moduleSerial}`)
          module.componentList.forEach((field: Recordable) => {
            field.renderConfig.visibleEmitter.remove(`addVisible_${field.fieldSerial}`)
            field.renderConfig.equationEmitter.remove(`equation_${field.fieldSerial}`)
          })
        })
      })
    }
  })
}

const positionsEffect = computed(() => {
  return positions.value
})
defineExpose({
  sure,
  positionsEffect
})
</script>
<style lang="scss" scoped>
.addForm-box {
  padding: 24px;
}
.title-box {
  display: flex;
  height: 38px;
  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}
.col-form-item-ul {
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  > li {
    padding: 0 10px;
  }
  .col-form-item-1 {
    width: 100%;
  }
  .col-form-item-2 {
    width: 50%;
  }
  .col-form-item-3 {
    width: 33.33%;
  }
  .col-form-item-4 {
    width: 25%;
  }
}
.sub-table-box {
  margin-top: 24px;
  .customTabs {
    border: none;
    //:deep(.el-tabs__nav) {
    //  transform: translateX(16px)!important;
    //}
    :deep(.el-tabs__header) {
      background: #fff;
    }
    :deep(.el-tabs__content) {
      border-top: none;
    }
    :deep(.el-tabs__item) {
      height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px 4px 0 0;
      margin: 0 4px -1px 0;
      background: #f4f4f5;
      &.is-active {
        background: #fff;
      }
    }
    :deep(.el-tabs__nav-next) {
      line-height: 32px;
    }
    :deep(.el-tabs__nav-prev) {
      line-height: 32px;
      border: 1px solid transparent;
    }
  }
}
</style>
